import { AuthUserPermission } from '@/modules/auth/models/AuthUserPermission';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class ResolvedUserPermissionSet extends BaseModel {
  clearDesk: AuthUserPermission;
  clearEstate: AuthUserPermission;
  clearVault: AuthUserPermission;

  constructor(model: Partial<ResolvedUserPermissionSet> = {}) {
    super(model);
    this.clearDesk = new AuthUserPermission(model.clearDesk);
    this.clearEstate = new AuthUserPermission(model.clearEstate);
    this.clearVault = new AuthUserPermission(model.clearVault);
  }
}
